import { Modal } from '@design-system/components/modal/modal';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import {
  convertToRestDayButtons,
  convertToRestDayModal,
} from './ConvertToRestDayModal.css';

type ConvertToRestDayModalProps = {
  isOpen: boolean;
  workoutTitle: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConvertToRestDayModal = ({
  isOpen,
  workoutTitle,
  onCancel,
  onConfirm,
}: ConvertToRestDayModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title="Convert to Rest Day?"
    modalClassName={convertToRestDayModal}
    testId="convert-to-rest-day"
  >
    <Typography variant="body" size="large" color="B-100">
      “{workoutTitle}” will show to members as a Rest Day.
      <br />
      You can&apos;t undo this.
    </Typography>
    <div className={convertToRestDayButtons}>
      <Button color="neutral" variant="text" onClick={onCancel}>
        Cancel
      </Button>
      <Button color="neutral" onClick={onConfirm}>
        Convert to Rest Day
      </Button>
    </div>
  </Modal>
);
